export default __webpack_public_path__ + "static/media/tile_bookings.933cb90b.jpg";